import {FC} from 'react'
import styles from './ValidationError.scss'

export interface EgovFormValidationError {
  name?: string
  num?: number
  errorMessage: string
  input?: string
  ranges?: {begin: number; end: number}[]
}

interface ValidationErrorProps {
  error: EgovFormValidationError
}

export const ValidationError: FC<ValidationErrorProps> = ({error: {errorMessage, input = '', ranges = []}}) => {
  interface InputChunk {
    inputSubStr: string
    highlight: boolean
  }

  const chars = Array.from(input)
  const {inputChunk: inputChunkInit, prevEnd} = ranges.reduce<{inputChunk: InputChunk[]; prevEnd: number}>(
    ({inputChunk: prevInputChunk, prevEnd}, {begin, end}) => ({
      inputChunk: [
        ...prevInputChunk,
        {inputSubStr: chars.slice(prevEnd + 1, begin).join(''), highlight: false},
        {inputSubStr: chars.slice(begin, end + 1).join(''), highlight: true},
      ],
      prevEnd: end,
    }),
    {
      inputChunk: [],
      prevEnd: -1,
    }
  )
  const inputChunk = [...inputChunkInit, {inputSubStr: chars.slice(prevEnd + 1).join(''), highlight: false}]
  const highlightedInput = inputChunk.map(({inputSubStr, highlight}, i) => (
    <span key={i} {...(highlight && {className: styles.invalidRangeText})}>
      {inputSubStr}
    </span>
  ))
  return (
    <div className={styles.validationError}>
      <div>{errorMessage}</div>
      {input && <div>入力値：{highlightedInput}</div>}
    </div>
  )
}
